// extracted by mini-css-extract-plugin
export default {"message":"ProductMessageBanner_message__O9ftP","container":"ProductMessageBanner_container__U+bDH"};